// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}
:host .user-account-skeleton {
  padding: 5px var(--space-lg) 0;
}
@media only screen and (min-width: 768px) {
  :host .user-account-skeleton {
    padding-top: var(--space-content-top-medium-screen);
  }
}
:host .user-account-skeleton .profile-card {
  display: flex;
  align-items: center;
  gap: var(--space-md);
  padding: var(--space-md);
  margin-top: var(--space-xs);
  border: 1.5px solid var(--color-grey-200);
  border-radius: var(--radius-xl);
}
:host .user-account-skeleton .profile-card .avatar {
  flex-shrink: 0;
  width: 60px;
  height: 60px;
  margin: 0;
  --border-radius: var(--radius-xl);
}
:host .user-account-skeleton .profile-card .profile-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
}
:host .user-account-skeleton .profile-card .profile-info .name {
  height: var(--font-line-height-md);
  width: 70%;
  margin: 0;
  --border-radius: var(--radius-md);
}
:host .user-account-skeleton .profile-card .profile-info .contact-info {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}
:host .user-account-skeleton .profile-card .profile-info .contact-info .contact-line {
  height: var(--font-line-height-xs);
  width: 55%;
  margin: 0;
  --border-radius: var(--radius-md);
}
:host .user-account-skeleton .profile-card .edit-action {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  margin: 0;
  --border-radius: var(--radius-pill);
}
:host .user-account-skeleton .friend-program {
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
  margin-top: var(--space-md);
  padding: 0;
}
:host .user-account-skeleton .friend-program .rewards-card {
  display: flex;
  flex-direction: column;
  gap: var(--space-lg);
  padding: var(--space-lg) var(--space-md);
  border: 1.5px solid var(--color-grey-200);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-secondary);
}
:host .user-account-skeleton .friend-program .rewards-card .rewards-header {
  display: flex;
  gap: var(--space-md);
  align-items: flex-start;
}
:host .user-account-skeleton .friend-program .rewards-card .rewards-header .rewards-icon {
  flex-shrink: 0;
  width: 32px;
  height: 32px;
  margin: 0;
  --border-radius: var(--radius-md);
}
:host .user-account-skeleton .friend-program .rewards-card .rewards-header .rewards-text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}
:host .user-account-skeleton .friend-program .rewards-card .rewards-header .rewards-text .rewards-title {
  height: var(--font-line-height-xl);
  width: 50%;
  margin: 0;
  --border-radius: var(--radius-md);
}
:host .user-account-skeleton .friend-program .rewards-card .rewards-header .rewards-text .rewards-description {
  display: flex;
  flex-direction: column;
  gap: var(--space-xs);
}
:host .user-account-skeleton .friend-program .rewards-card .rewards-header .rewards-text .rewards-description .description-line {
  height: var(--font-line-height-sm);
  width: 100%;
  margin: 0;
  --border-radius: var(--radius-md);
}
:host .user-account-skeleton .friend-program .rewards-card .rewards-header .rewards-text .rewards-description .description-line:last-child {
  width: 70%;
}
:host .user-account-skeleton .friend-program .rewards-card .invite-code-row {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
}
:host .user-account-skeleton .friend-program .rewards-card .invite-code-row .code-input {
  flex: 1;
  min-width: 0;
  height: 48px;
  margin: 0;
  --border-radius: var(--radius-lg);
}
:host .user-account-skeleton .friend-program .rewards-card .invite-code-row .copy-button {
  flex-shrink: 0;
  width: 110px;
  height: 48px;
  margin: 0;
  --border-radius: var(--radius-lg);
}
:host .user-account-skeleton .friend-program .progress-section {
  display: flex;
  flex-direction: column;
  gap: var(--space-md);
}
:host .user-account-skeleton .friend-program .progress-section .progress-title {
  height: var(--font-line-height-xl);
  width: 45%;
  margin: 0;
  --border-radius: var(--radius-md);
}
:host .user-account-skeleton .friend-program .progress-section .progress-stats {
  display: flex;
  gap: var(--space-sm);
  width: 100%;
  overflow: hidden;
}
:host .user-account-skeleton .friend-program .progress-section .progress-stats .stat-card {
  flex: 0 0 200px;
  width: 200px;
  height: 160px;
  margin: 0 0 var(--space-md);
  --border-radius: var(--radius-md);
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/skeleton-user-account/skeleton-user-account.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;AACJ;AACI;EACI,8BAAA;AACR;AACQ;EAHJ;IAIQ,mDAAA;EAEV;AACF;AAAQ;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,wBAAA;EACA,2BAAA;EAEA,yCAAA;EACA,+BAAA;AACZ;AACY;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;AAChB;AAEY;EACI,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AAAhB;AAEgB;EACI,kCAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;AAApB;AAGgB;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;AADpB;AAGoB;EACI,kCAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;AADxB;AAMY;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,mCAAA;AAJhB;AAQQ;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,2BAAA;EACA,UAAA;AANZ;AAQY;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,wCAAA;EAEA,yCAAA;EACA,+BAAA;EACA,mCAAA;AAPhB;AASgB;EACI,aAAA;EACA,oBAAA;EACA,uBAAA;AAPpB;AASoB;EACI,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;AAPxB;AAUoB;EACI,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,oBAAA;AARxB;AAUwB;EACI,kCAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;AAR5B;AAWwB;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;AAT5B;AAW4B;EACI,kCAAA;EACA,WAAA;EACA,SAAA;EACA,iCAAA;AAThC;AAWgC;EACI,UAAA;AATpC;AAgBgB;EACI,aAAA;EACA,mBAAA;EACA,oBAAA;AAdpB;AAgBoB;EACI,OAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;AAdxB;AAiBoB;EACI,cAAA;EACA,YAAA;EACA,YAAA;EACA,SAAA;EACA,iCAAA;AAfxB;AAoBY;EACI,aAAA;EACA,sBAAA;EACA,oBAAA;AAlBhB;AAoBgB;EACI,kCAAA;EACA,UAAA;EACA,SAAA;EACA,iCAAA;AAlBpB;AAqBgB;EACI,aAAA;EACA,oBAAA;EACA,WAAA;EACA,gBAAA;AAnBpB;AAqBoB;EACI,eAAA;EACA,YAAA;EACA,aAAA;EACA,2BAAA;EACA,iCAAA;AAnBxB","sourcesContent":[":host {\r\n    display: block;\r\n\r\n    .user-account-skeleton {\r\n        padding: 5px var(--space-lg) 0;\r\n\r\n        @media only screen and (min-width: 768px) {\r\n            padding-top: var(--space-content-top-medium-screen);\r\n        }\r\n\r\n        .profile-card {\r\n            display: flex;\r\n            align-items: center;\r\n            gap: var(--space-md);\r\n            padding: var(--space-md);\r\n            margin-top: var(--space-xs);\r\n\r\n            border: 1.5px solid var(--color-grey-200);\r\n            border-radius: var(--radius-xl);\r\n\r\n            .avatar {\r\n                flex-shrink: 0;\r\n                width: 60px;\r\n                height: 60px;\r\n                margin: 0;\r\n                --border-radius: var(--radius-xl);\r\n            }\r\n\r\n            .profile-info {\r\n                flex: 1;\r\n                min-width: 0;\r\n                display: flex;\r\n                flex-direction: column;\r\n                gap: var(--space-sm);\r\n\r\n                .name {\r\n                    height: var(--font-line-height-md);\r\n                    width: 70%;\r\n                    margin: 0;\r\n                    --border-radius: var(--radius-md);\r\n                }\r\n\r\n                .contact-info {\r\n                    display: flex;\r\n                    flex-direction: column;\r\n                    gap: var(--space-xs);\r\n\r\n                    .contact-line {\r\n                        height: var(--font-line-height-xs);\r\n                        width: 55%;\r\n                        margin: 0;\r\n                        --border-radius: var(--radius-md);\r\n                    }\r\n                }\r\n            }\r\n\r\n            .edit-action {\r\n                flex-shrink: 0;\r\n                width: 34px;\r\n                height: 34px;\r\n                margin: 0;\r\n                --border-radius: var(--radius-pill);\r\n            }\r\n        }\r\n\r\n        .friend-program {\r\n            display: flex;\r\n            flex-direction: column;\r\n            gap: var(--space-lg);\r\n            margin-top: var(--space-md);\r\n            padding: 0;\r\n\r\n            .rewards-card {\r\n                display: flex;\r\n                flex-direction: column;\r\n                gap: var(--space-lg);\r\n                padding: var(--space-lg) var(--space-md);\r\n\r\n                border: 1.5px solid var(--color-grey-200);\r\n                border-radius: var(--radius-md);\r\n                box-shadow: var(--shadow-secondary);\r\n\r\n                .rewards-header {\r\n                    display: flex;\r\n                    gap: var(--space-md);\r\n                    align-items: flex-start;\r\n\r\n                    .rewards-icon {\r\n                        flex-shrink: 0;\r\n                        width: 32px;\r\n                        height: 32px;\r\n                        margin: 0;\r\n                        --border-radius: var(--radius-md);\r\n                    }\r\n\r\n                    .rewards-text {\r\n                        flex: 1;\r\n                        min-width: 0;\r\n                        display: flex;\r\n                        flex-direction: column;\r\n                        gap: var(--space-md);\r\n\r\n                        .rewards-title {\r\n                            height: var(--font-line-height-xl);\r\n                            width: 50%;\r\n                            margin: 0;\r\n                            --border-radius: var(--radius-md);\r\n                        }\r\n\r\n                        .rewards-description {\r\n                            display: flex;\r\n                            flex-direction: column;\r\n                            gap: var(--space-xs);\r\n\r\n                            .description-line {\r\n                                height: var(--font-line-height-sm);\r\n                                width: 100%;\r\n                                margin: 0;\r\n                                --border-radius: var(--radius-md);\r\n\r\n                                &:last-child {\r\n                                    width: 70%;\r\n                                }\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n\r\n                .invite-code-row {\r\n                    display: flex;\r\n                    align-items: center;\r\n                    gap: var(--space-sm);\r\n\r\n                    .code-input {\r\n                        flex: 1;\r\n                        min-width: 0;\r\n                        height: 48px;\r\n                        margin: 0;\r\n                        --border-radius: var(--radius-lg);\r\n                    }\r\n\r\n                    .copy-button {\r\n                        flex-shrink: 0;\r\n                        width: 110px;\r\n                        height: 48px;\r\n                        margin: 0;\r\n                        --border-radius: var(--radius-lg);\r\n                    }\r\n                }\r\n            }\r\n\r\n            .progress-section {\r\n                display: flex;\r\n                flex-direction: column;\r\n                gap: var(--space-md);\r\n\r\n                .progress-title {\r\n                    height: var(--font-line-height-xl);\r\n                    width: 45%;\r\n                    margin: 0;\r\n                    --border-radius: var(--radius-md);\r\n                }\r\n\r\n                .progress-stats {\r\n                    display: flex;\r\n                    gap: var(--space-sm);\r\n                    width: 100%;\r\n                    overflow: hidden;\r\n\r\n                    .stat-card {\r\n                        flex: 0 0 200px;\r\n                        width: 200px;\r\n                        height: 160px;\r\n                        margin: 0 0 var(--space-md);\r\n                        --border-radius: var(--radius-md);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
